import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "qin-filter-bar" }
const _hoisted_2 = { class: "qin-filter-bar__header" }
const _hoisted_3 = { class: "qin-filter-bar__title" }
const _hoisted_4 = { class: "qin-filter-bar__apply-button" }
const _hoisted_5 = { class: "qin-button__text" }
const _hoisted_6 = { class: "qin-filter-bar__elements-wrapper" }
const _hoisted_7 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_xl-xl g-row--justify_center g-row--align_end" }
const _hoisted_8 = { class: "default-checker default-checker--filter" }
const _hoisted_9 = { class: "default-checker__checkbox default-checker__checkbox--ma_none" }
const _hoisted_10 = ["onUpdate:modelValue", "value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "qin-checkbox-main__label" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/static/app/check-icon.svg" })
], -1)
const _hoisted_12 = { class: "default-checker__description" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "multiselect__single" }
const _hoisted_15 = { class: "transactions-row-status transactions-row-status--for-status" }
const _hoisted_16 = { class: "transactions-row-status__value" }
const _hoisted_17 = { class: "g-cell g-cols g-cols--12-fhd" }
const _hoisted_18 = { class: "g-row__clear-button" }
const _hoisted_19 = { class: "qin-button__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_arrow_down = _resolveComponent("i-arrow-down")!
  const _component_d_control_input = _resolveComponent("d-control-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.$t('Filters')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "qin-button qin-button--main qin-button--dark qin-button--full_width",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilters()))
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.$t('Clear')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        ($setup.props.checkers)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.props.checkers, (ckecker) => {
              return (_openBlock(), _createElementBlock("div", {
                key: ckecker.name,
                class: _normalizeClass(["g-cell g-cols", ckecker.cols || 'g-cols--auto g-cols--12-fhd'])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["qin-checkbox-main", $setup.form[ckecker.name] ? 'qin-checkbox-main--active' : 'qin-checkbox-main'])
                    }, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "checker",
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => (($setup.form[ckecker.name]) = $event),
                          value: $setup.form[ckecker.name]
                        }, null, 8, _hoisted_10), [
                          [_vModelCheckbox, $setup.form[ckecker.name]]
                        ]),
                        _hoisted_11
                      ])
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(ckecker.label) + " ", 1),
                      (ckecker?.counter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.attentionsCount ? `(${$setup.attentionsCount})` : ''), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 2))
            }), 128))
          : _createCommentVNode("", true),
        ($setup.props.fields)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.fields, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.name,
                  class: _normalizeClass(["g-cell g-cols", field.cols || 'g-cols--auto g-cols--12-fhd'])
                }, [
                  _createVNode(_component_d_control_input, _mergeProps({
                    component: field.component,
                    "input-label": field.label,
                    name: field.name,
                    rules: field.rules,
                    ref_for: true,
                    ref: field.name,
                    type: field.type
                  }, field, {
                    modelValue: $setup.form[field.name],
                    "onUpdate:modelValue": ($event: any) => (($setup.form[field.name]) = $event),
                    placeholder: field.placeholder || '',
                    onOnChange: ($event: any) => (field.component == 'd-control-flatpickr' ? $setup.emit('checkValues', $setup.form) : () => {}),
                    onOpen: ($event: any) => ($setup.optionsGetter($setup.props.objectType, field))
                  }), _createSlots({
                    caret: _withCtx(({ toggle }) => [
                      _createVNode(_component_i_arrow_down, { class: "multiselect-caret" })
                    ]),
                    _: 2
                  }, [
                    (field?.custom)
                      ? {
                          name: "singleLabel",
                          fn: _withCtx(({ option }) => [
                            _createElementVNode("span", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", {
                                  class: "transactions-row-status__icon",
                                  style: _normalizeStyle({ background: option.color })
                                }, null, 4),
                                _createElementVNode("div", _hoisted_16, _toDisplayString(option.title), 1)
                              ])
                            ])
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1040, ["component", "input-label", "name", "rules", "type", "modelValue", "onUpdate:modelValue", "placeholder", "onOnChange", "onOpen"])
                ], 2))
              }), 128)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "qin-button qin-button--main qin-button--accent qin-button--full_width",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.applyFilters()), ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString($setup.$t('Apply')), 1)
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}